import Vue from 'vue'; //首先引入vue
import Vuex from 'vuex'; //引入vuex
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 这里面写入数据
        api: 'http://creative.newairtek.com',
        Interface:'',
        seachBol: true,
        isLoginDate:false
    },
    getters:{
        // getters 类似 computed
        // 在这里面写个方法
    },
    mutations:{
        isLoginDate(state,type){
            state.isLoginDate = type
        },
        // mutations 类似methods
        // 写方法对数据做出更改

        //对数据和接口地址进行简单封装
        increment:function (state,token_url) {
            state.Interface = state.api + token_url.url+'?token=' + token_url.token
        }


    },
    actions:{
        // actions 类似methods
        // 写方法对数据做出更改(异步操作)
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js